import { FC } from "react";
import { Show } from "shared/components";
import {
  Tooltip,
  TooltipContent,
  TooltipTrigger
} from "shared/components/Tooltip";
import { cx } from "shared/utils";

interface OptionButtonProps {
  option: string;
  displayText?: string;
  isDisabled: boolean;
  onClick: () => void;
  optionsWithSegmentMap?: Record<string, string>;
  segmentName?: string;
  isLastStep?: boolean;
}

export const OptionButton: FC<OptionButtonProps> = ({
  option,
  displayText,
  isDisabled,
  onClick,
  optionsWithSegmentMap,
  segmentName,
  isLastStep
}) => {
  return (
    <Tooltip placement="right">
      <TooltipTrigger className="w-full">
        <button
          className={cx(
            "w-full text-left py-3 px-4 text-sm rounded-md",
            isDisabled
              ? "bg-alpha-40 text-content-200"
              : "text-content-700 hover:bg-alpha-20 cursor-pointer"
          )}
          onClick={onClick}
          disabled={isDisabled}
        >
          {displayText || option}
        </button>
      </TooltipTrigger>
      <Show if={isDisabled}>
        <TooltipContent className="rounded-lg border bg-alpha-800 p-4 text-sm text-white z-[51]">
          <span>{displayText || option} is already in&nbsp;</span>
          <span className="max-w-[80px] truncate">
            &quot;{optionsWithSegmentMap?.[option] || segmentName || "this"}
            &quot;
          </span>
          <span>&nbsp;{isLastStep ? "group" : "segment"}</span>
        </TooltipContent>
      </Show>
    </Tooltip>
  );
};
